"use strict"

import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"

import RunDetailsDiv from "../resources/RunDetailsDiv"

export default function RunDetailsModal({ run, show, onHide, intl }) {
  const [selectedRun, setSelectedRun] = useState(run)

  useEffect(() => setSelectedRun(run), [run])

  return (
    <>
      <Modal
        size={"xl"}
        dialogClassName={"common-modal"}
        show={show}
        onHide={onHide}
        style={{ overflowX: "scroll", overflowY: "scroll" }}
        backdrop={"static"}
      >
        <Modal.Header closeButton>
          <Modal.Title className={"text-center"}>
            {selectedRun.name} --&nbsp;
            {intl.formatMessage({ id: "general.details" })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id={"runDetailsBody"}>
            <RunDetailsDiv selectedRun={selectedRun} intl={intl} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ display: "flex", float: "left" }}
            type={"reset"}
            variant={"outline-primary"}
            onClick={(e) => {
              e.preventDefault()
              onHide()
            }}
          >
            {intl.formatMessage({ id: "general.cancelButton" })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
